import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { PropertyList } from '../../../domain/model/properties/propertyList';
import { AuthenticationService } from '../../../security/auth/authentication.service';
import { RouterLink, RouterLinkActive, Router } from "@angular/router";

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ExternalUser } from '../../../domain/model/account/externalUser';
import { OwnerDropDown } from '../../../domain/model/common/ownerDropDown';
import { PropertyService } from '../../../domain/service/propertyService';

@Component({
  selector: 'app-properties-list',
  templateUrl: './properties-list.component.html',
  styleUrl: './properties-list.component.css'
})
export class PropertiesListComponent implements OnInit {
  // Setters because the paginator/sort render inside an @if (!loading) block,
  // so they only become available after data has loaded.
  @ViewChild(MatPaginator) set matPaginator(paginator: MatPaginator) {
    if (paginator) {
      this.dataSource.paginator = paginator;
    }
  }
  @ViewChild(MatSort) set matSort(sort: MatSort) {
    if (sort) {
      this.dataSource.sort = sort;
    }
  }

  filters = {
    searchTerm: '',
    status: '',
    owner: ''
  };

  /** Mobile-only: the search/filter controls live in a bottom-sheet modal. */
  mobileFiltersOpen = false;

  loading = true;
  dataSource = new MatTableDataSource<PropertyList>([]);
  externalUser: ExternalUser | null;
  propertyOwners: OwnerDropDown[] = [];

  displayedColumns: string[] = ['propertyId', 'streetAddress', 'type', 'lastPayment', 'statusDescription'];
  accountId: number = 0;

  constructor(
    private readonly router: Router,
    private readonly auth: AuthenticationService,
    private readonly propertyService: PropertyService
  ) {
    this.externalUser = this.auth.getCurrentUser2();
    const accountId = this.externalUser?.accountId?.toString() ?? '0';

    if (this.externalUser?.accountType == 2) {
      this.displayedColumns = ['propertyId', 'streetAddress', 'type', 'ownerName', 'statusDescription'];
      this.propertyService.getPropertiesOwners(accountId).subscribe(data => {
        this.propertyOwners = data;
      });
    }

    this.dataSource.filterPredicate = (data, filter) => {
      const searchTerms = JSON.parse(filter);
      if (searchTerms.status.toLowerCase() == 'all') {
        searchTerms.status = '';
      }
      return (
        (!searchTerms.searchTerm ||
          data.propertyId.toString().includes(searchTerms.searchTerm.toLowerCase()) ||
          data.streetAddress.toString().toLowerCase().includes(searchTerms.searchTerm.toLowerCase())) &&
        (!searchTerms.status || data.status.toString().includes(searchTerms.status)) &&
        (!searchTerms.owner || data.ownerName.toString().includes(searchTerms.owner))
      );
    };

    this.loading = true;
    this.propertyService.getProperties(accountId).subscribe({
      next: data => {
        this.dataSource.data = data;
        this.loading = false;
      },
      error: () => {
        this.dataSource.data = [];
        this.loading = false;
      }
    });
  }

  ngOnInit(): void {}

  onRowClick(row: any) {
    this.router.navigate(['app/properties/propertyDetail', row.propertyId]);
  }

  onNewPorpertyClick() {
    this.router.navigate(['app/AddNewProperty']);
  }

  applyFilter() {
    this.dataSource.filter = JSON.stringify(this.filters);
  }

  /** Number of non-default filters, shown as a badge on the mobile trigger. */
  get activeFilterCount(): number {
    let count = 0;
    if (this.filters.searchTerm) count++;
    if (this.filters.status) count++;
    if (this.filters.owner) count++;
    return count;
  }

  openMobileFilters() {
    this.mobileFiltersOpen = true;
  }

  closeMobileFilters() {
    this.mobileFiltersOpen = false;
  }
}
